import type { ReactElement } from 'react';
import { Anchor, HoverCard, Text, Tooltip } from '@mantine/core';
import { Link } from 'react-router-dom';

/**
 * MED-1346: the tooltip on a 1:1 miss tag. With historyHref (staff only) it is
 * a hover card, so the pointer can reach the "See 1:1 history" link.
 */
export function MissTagTooltip({
  description,
  historyHref,
  width,
  children,
}: {
  description: string;
  historyHref?: string;
  width: number;
  children: ReactElement;
}) {
  if (!historyHref) {
    return (
      <Tooltip label={description} withArrow position="top" multiline w={width}>
        {children}
      </Tooltip>
    );
  }
  return (
    <HoverCard withArrow position="top" width={width} shadow="md" withinPortal>
      <HoverCard.Target>{children}</HoverCard.Target>
      <HoverCard.Dropdown onClick={(e) => e.stopPropagation()}>
        <Text size="xs">{description}</Text>
        <HistoryLink href={historyHref} />
      </HoverCard.Dropdown>
    </HoverCard>
  );
}

/** MED-1346: staff only. The Data Library "1:1 history" tab for this participant. */
export function HistoryLink({ href }: { href: string }) {
  return (
    <Anchor component={Link} to={href} size="xs" fw={600} mt={4} display="inline-block">
      See 1:1 history
    </Anchor>
  );
}
